import { render, staticRenderFns } from "./StepAutoGeneratePolicySuccess.vue?vue&type=template&id=12e9febc&"
import script from "./StepAutoGeneratePolicySuccess.vue?vue&type=script&lang=js&"
export * from "./StepAutoGeneratePolicySuccess.vue?vue&type=script&lang=js&"
import style0 from "./StepAutoGeneratePolicySuccess.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports